import axios from 'axios';

export default {
    search: (query) => {
        return axios.post("/api/search", query)
            .then(response => response.data);
    },
    archive: (query) => {
        return axios.post("/api/search/archive", query)
            .then(response => response.data);
    },
    getFilters: () => {
        return axios.get("/api/search/filters")
            .then(response => response.data);
    },
    getYears: () => {
        return axios.get("/api/search/years")
            .then(response => response.data);
    }
}